<template>
  <b-card class="m-2" no-body>

    <b-table :fields="fields" hover no-border-collapse :items="items" stacked="sm" responsive>
      <template #table-busy>
        <div class="text-center text-dark">
          <b-spinner class="align-middle"></b-spinner>
          <strong class="loading-text">Carregando...</strong>
        </div>
      </template>
      <template v-slot:cell(Status)="row">
        <span style="font-size: 20px;">
          <font-awesome-icon v-if="row.item.Status == 'Y'" icon="check" style="color: green" />
          <font-awesome-icon v-else icon="times" style="color: red" />
        </span>
      </template>
      <template v-slot:cell(actions)="row">
        <btn-assinar-pcm v-if="row.item.Status == 'N'" :assinatura="row.item" :situacao="pcm.DsStatusPc"
          @assinar="openAssinaturaModal(row.item)"></btn-assinar-pcm>
        <div v-else class="actions-icons">
          <b-link class="text-dark"
            @click="download(row.item.CodSignatario + '_' + pcm.IdPrestacaoConta, row.item.ConteudoArquivoAssinado)">
            <font-awesome-icon icon="receipt" />
            <div style="font-size: 12px">Registro</div>
          </b-link>
        </div>
      </template>
    </b-table>

    <router-view></router-view>
  </b-card>
</template>

<script lang="ts">
import BtnAssinarPcm from "@/components/entregas/pcm/BtnAssinarPcm.vue";
import pcmService from "@/services/entregas/pcmService";
import { store } from "@/store";
import { AssinaturaDeContasMensal } from '@/types/entregas/pcm/assinatura-contas-mensais';
import { TableField } from "@/types/table-field";
import { UtilsTS } from '@/utilsts';
import { mixins } from 'vue-class-component';
import { Component, Vue } from 'vue-property-decorator';
import { fieldsAssinaturaPCM } from '@/types/entregas/pcm/fields-pcm-assinaturas'
import { PrestacaoDeContasMensal } from "@/types/entregas/pcm/prestacao-contas-mensal";
import { PropType } from "vue";
const CompProps = Vue.extend({
  name: 'AssinaturaDigitalPCM',
  components: { BtnAssinarPcm },
  props: {
    pcm: {
      type: Object as PropType<PrestacaoDeContasMensal>
    }
  },
})

@Component
export default class AssinaturaDigitalPCM extends mixins(UtilsTS, CompProps) {
  fields: TableField[] = fieldsAssinaturaPCM
  itemsAssinatura = [
    {
      IdPrestacaoConta: this.pcm.IdPrestacaoConta, LabelSignatario: 'Gestor', Status: 'N', UsuarioResponsavel: '-',
      NomeSignatario: '-', DataAssinatura: '-', CodSignatario: 'G',
      ConteudoArquivoAssinado: ''
    },
    {
      IdPrestacaoConta: this.pcm.IdPrestacaoConta, LabelSignatario: 'Responsável', Status: 'N', UsuarioResponsavel: '-',
      NomeSignatario: '-', DataAssinatura: '-', CodSignatario: 'c',
      ConteudoArquivoAssinado: ''
    },
  ]
  items: AssinaturaDeContasMensal[] = []
  currentItem: null

  async getAssinaturasPCM() {
    try {
      store.blockScreen = true
      let registrosAssinatura = await pcmService.registrosAssinatura(this.pcm.IdPrestacaoConta)
      registrosAssinatura.data.map((as: any) => {
        let pos = as.CodSignatario == 'G' ? 0 : 1
        this.itemsAssinatura[pos].UsuarioResponsavel = this.capitalize(as.UsuarioResponsavel);
        this.itemsAssinatura[pos].NomeSignatario = this.capitalize(as.NomeSignatario);
        this.itemsAssinatura[pos].DataAssinatura = this.formatData(as.DataAssinatura);
        this.itemsAssinatura[pos].ConteudoArquivoAssinado = as.ConteudoArquivoAssinado;
        this.itemsAssinatura[pos].Status = 'Y';
        this.itemsAssinatura[pos].CodSignatario = as.CodSignatario
      })
      this.items = Object.assign([new AssinaturaDeContasMensal()], this.itemsAssinatura);
    } catch (e: any) {
      this.$toast.error(e.message ? e.message : e);
      this.$router.push('/entrega/prestacoes-contas-mensais');
    } finally {
      store.blockScreen = false
    }
  }

  openAssinaturaModal(item) {
    this.currentItem = item
    this.$router.push("/entrega/prestacoes-contas-mensais/assinatura/" + this.pcm.IdPrestacaoConta + "/" + item.CodSignatario);
  }

  async mounted() {
    this.getAssinaturasPCM()
  }


  async urltoFile(url, filename, mimeType) {
    return await (fetch(url).then(function (res) { return res.arrayBuffer() }).then(function (buf) { return new File([buf], filename, { type: mimeType }) }));
  }

  async download(filename, content): Promise<void> {
    var element = document.createElement('a');
    var file = await (fetch('data:text/plain;base64,' + content).then(function (res) { return res.arrayBuffer() }).then(function (buf) { return new File([buf], filename + '.p7s', { type: 'application/pkcs7-signed-data' }) }));
    element.setAttribute('href', URL.createObjectURL(file));
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }
};
</script>

<style scoped>
.card-body {
  padding: 1.25rem 0 !important;
}

div.row>div>span:first-child {
  font-weight: bolder;
  /*display: block;*/
}
</style>